export default __webpack_public_path__ + "static/media/check.faefdca7.svg";